<template>
  <v-row
    v-if="$vuetify.breakpoint.mdAndUp"
    class="flex-nowrap"
  >
    <!-- Provider -->
    <v-col
      class="d-flex flex-column justify-center align-center
                  table-right-border table-right-border-light result-columns-align-width"
    >
      <img
        v-if="details.imageSiteRemote"
        :src="details.imageSiteRemote"
        :alt="details.brokerFullName"
        class="provider-logo"
        @click="$emit('open-more-info')"
      >
      <div
        v-else
        class="font-weight-bold text-center"
      >
        {{ details.insurer }}
      </div>
    </v-col>
    <!-- Price -->
    <v-col
      class="d-flex flex-column justify-center align-center
                                  table-right-border table-right-border-light result-columns-align-width"
      @click="$emit('open-more-info')"
    >
      <results-price
        :quote="quote"
        :monthly="isViewMonthly"
        :cashback="cashback"
        :selected-optional-extras="[]"
      />
    </v-col>

    <!-- Cover Type -->
    <v-col
      class="d-flex flex-column justify-center align-center
                                  table-right-border table-right-border-light
                                  text-center result-columns-align-width"
    >
      <span class="font-weight-bold text-h6">{{ coverType }}</span>
    </v-col>

    <!-- Per Accident -->
    <v-col
      class="d-flex flex-column justify-center align-center
                                  table-right-border table-right-border-light
                                  text-center result-columns-align-width"
    >
      <p class="mb-0 caption">Up to</p>
      <p class="mb-0 font-weight-bold fs-16">{{ helpers.getExtrasPrice(optionalExtra.vetsFee) }}</p>
      <p
        v-if="optionalExtra.vetsFee.extraText"
        class="mb-0 caption"
      >
        {{ optionalExtra.vetsFee.extraText }}
      </p>
    </v-col>

    <!-- Policy Limit -->
    <v-col
      class="d-flex flex-column justify-center align-center
                                  table-right-border table-right-border-light
                                  text-center result-columns-align-width"
    >
      <p class="font-weight-bold fs-16 mb-0">{{ helpers.getExtrasPrice(optionalExtra.annualPolicyLimit) }}</p>
      <p class="mb-0 caption">per year</p>
    </v-col>

    <!-- Vet Excess -->
    <v-col
      class="d-flex flex-column justify-center align-center
                                  table-right-border table-right-border-light
                                  text-center result-columns-align-width"
    >
      <p class="mb-0 font-weight-bold fs-16">{{ helpers.getExtrasPrice(optionalExtra.vetExcess) }}</p>
      <p class="mb-0 caption">{{ details.compulsoryExtraText }}</p>
    </v-col>

    <!-- Policy details -->
    <v-col
      class="d-flex flex-column justify-center align-center text-center
                       result-columns-align-width"
    >
      <v-btn
        rounded
        color="success"
        @click="$emit('click-policy-details')"
      >
        <span>More info</span>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
import ResultsPrice from '@/components/pet/Results/ResultsPrice.vue';
import { camelCase, startCase } from 'lodash';

export default {
  name: 'quote-desktop',
  components: {
    ResultsPrice,
  },
  inject: ['helpers'],
  props: {
    quote: {
      type: Object,
      required: true,
    },
    isViewMonthly: {
      type: Boolean,
      required: true,
    },
    details: {
      type: Object,
      required: true,
    },
    optionalExtra: {
      type: Object,
      required: true,
    },
  },
  computed: {
    coverType () {
      const formattedCoverType = startCase(camelCase(this.details.coverType));

      return formattedCoverType === 'Accidents Only' ? 'Accident Only' : formattedCoverType;
    },
    cashback () {
      return +this.quote.details[0].cashback;
    },
  },
};
</script>

<style scoped lang="scss">
.provider-logo {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>
